import ContainerForm from 'components/ContainerForm';
import { InfiniteComp } from 'components/infinite-scroll/InfiniteComp';
import { InputTitle } from 'components/input/InputTitle';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import {
  Radio,
  Spacing,
  Switch,
  Table,
  Tabs,
  TextInput,
  Typography,
  closeModal,
  openModal,
} from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { ThumbnailComp } from 'modules/classes/components/ThumbnailComp';
import { CustomTabs } from 'modules/classes/styles/tab';
import { BorderContainer } from 'modules/dashboard/styles/common';

import { CustomRadio } from '../styles/dashboard';
import { GenerateIcon, OveralExercise, SwitchContainer } from '../styles/lesson';

import { ReactComponent as PantIcon } from 'assets/icons/black 1.svg';
import { ReactComponent as LeadingIcon } from 'assets/icons/leading-icon.svg';
import { ReactComponent as ShirtIcon } from 'assets/icons/shirt 2.svg';
import { ReactComponent as TooltipIcon } from 'assets/icons/tooltip.svg';

import { isEmpty } from 'lodash';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { AddItemModal } from '../components/AddItemModal';
import { ExerciseTable } from '../components/ExerciseTable';
import { Footer } from '../components/Footer';
import { HeaderDetailPage } from '../components/HeaderDetailPage';
import { getExercisesInLessonColumn } from '../core/columns';
import { useLessonsFormController } from '../core/controller/lessons-form';
import { levelTabs } from '../core/tabs';

export const AddLessonPage = () => {
  const {
    lessonId,
    values,
    handleChange,
    handleSubmit,
    disabled,
    disabledButton,
    types,
    onChangeType,
    onCancel,
    exercisesData,
    searchValue,
    onChangeSearchValue,
    selectedExercises,
    onChangeSelectedExercises,
    selectedData,
    handleAddExercisesToLesson,
    handleDeleteExerciseInLesson,
    onChangeValueSelectedExercises,
    handleDeleteLesson,
    lessonDetail,
    goBack,
    onDragEnd,
    onTabClickLevel,
    activeLevel,
    exercisesDataCommon,
    onChangeValueSelectedExercisesDIY,
    handleDeleteExerciseDIYInLesson,
    isEditExercises,
    handleChangeEditExercises,
    handleCalculateTotalUpperAndLower,
    hasMore,
    handleLoadMoreExercise,
    handleGenerate,
    isGenerating,
    thumbnailUrl,
    handleGetWidthAndHeightThumbnail,
    handleRemoveThumbnail,
    onChangeThumbnail,
  } = useLessonsFormController();

  const columns = getExercisesInLessonColumn(onChangeSelectedExercises, selectedExercises);

  const { averageUpper, averageLower } = handleCalculateTotalUpperAndLower();

  return (
    <ContainerForm
      onCancel={onCancel}
      onSubmit={handleSubmit}
      disabled={lessonId ? disabledButton : disabled}
      titleSubmit={lessonId ? 'Save' : 'Add'}
      titleCancel={lessonId && 'Cancel changes'}
      disabledCancel={lessonId ? disabledButton : false}
    >
      <>
        <HeaderDetailPage
          title={lessonId ? String(lessonDetail?.name) : 'Add lesson'}
          showAction={Boolean(lessonId)}
          actions={[
            {
              label: 'Delete',
              onClick: () => openModal(MODAL_KEY.DELETE_LESSON),
            },
          ]}
          goBack={goBack}
        />
        <BorderContainer spacing="md" placement="bottom" type="margin" className="pb-0">
          <div className="max-w-800">
            <InputTitle
              style={{ background: COLOR_CONFIG.white }}
              title={
                <Typography height={28} color="#222" weight={500} size={20}>
                  Lesson details
                </Typography>
              }
            />
            <Typography
              style={{ margin: '18px 0 6px 0' }}
              size={14}
              weight={600}
              height={20}
              color="#808080"
            >
              Lesson name
            </Typography>
            <TextInput
              name="name"
              className="max-w-800 rounded-12"
              value={values.name}
              onChange={handleChange}
              maxLength={80}
            />
            <Spacing className="mt-24" spacing="md" placement="bottom" type="margin">
              <InputTitle
                title={
                  <Typography
                    weight={600}
                    size={14}
                    height={20}
                    color={COLOR_CONFIG['neutral-text']}
                  >
                    Lesson type
                  </Typography>
                }
                icon={<TooltipIcon />}
              />
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                {types.map((type, index) => {
                  const checked = type?.id === values.type;

                  return (
                    <CustomRadio>
                      <Radio key={index} checked={checked} onClick={onChangeType(type)}>
                        <Typography variant="body-2" color={COLOR.surfaceNeutralBold['neutral-11']}>
                          {type.name}
                        </Typography>
                      </Radio>
                    </CustomRadio>
                  );
                })}
              </div>
            </Spacing>
          </div>
        </BorderContainer>

        <BorderContainer
          spacing="md"
          placement="bottom"
          type="margin"
          className={isEditExercises ? '' : 'p-0'}
        >
          <InputTitle
            title={
              <Typography height={28} color="#222" weight={500} size={20}>
                Exercises
              </Typography>
            }
          />

          <Spacing spacing="md" placement="bottom" type="margin" style={{ paddingTop: 10 }}>
            <CustomTabs>
              <Tabs
                variant="text"
                items={levelTabs()}
                // activeKey={locationPath}
                onTabClick={onTabClickLevel}
                tabItemStyle={{
                  height: 32,
                  background: 'transparent',
                }}
                className="wrap-tabs"
                isLine={true}
              />
            </CustomTabs>
          </Spacing>

          <Spacing spacing="md" placement="bottom" type="margin">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <OveralExercise>
                <Typography size={14} height={20} color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {exercisesDataCommon?.[activeLevel.value].length} exercises
                </Typography>
                <Typography size={20} color="rgba(0, 0, 0, 0.25)">
                  &bull;
                </Typography>
                <ShirtIcon />
                <Typography size={14} height={20} color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {averageUpper}% upper body
                </Typography>
                <Typography size={20} color="rgba(0, 0, 0, 0.25)">
                  &bull;
                </Typography>
                <PantIcon />
                <Typography size={14} height={20} color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {averageLower}% lower body
                </Typography>
              </OveralExercise>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <SwitchContainer>
                  <Switch checked={isEditExercises.value} onChange={handleChangeEditExercises} />
                  <Typography size={14} height={20} color={COLOR.surfaceNeutralBold['neutral-11']}>
                    {isEditExercises.value ? 'Disable' : 'Enable'} edit
                  </Typography>
                </SwitchContainer>

                {!isGenerating.value && !lessonId && (
                  <GenerateIcon onClick={handleGenerate}>
                    <LeadingIcon />
                    <Typography size={16} weight={600} color={COLOR.purpel['purpel-6']} height={22}>
                      Auto generate
                    </Typography>
                  </GenerateIcon>
                )}
              </div>
            </div>
          </Spacing>
          <>
            {!isEmpty(selectedData) ||
            (exercisesDataCommon && !isEmpty(exercisesDataCommon[activeLevel.value])) ? (
              <ExerciseTable
                exercises={exercisesDataCommon?.[activeLevel.value] || []}
                onChangeValueSelectedExercises={onChangeValueSelectedExercisesDIY}
                onDelete={handleDeleteExerciseDIYInLesson}
                onDragEnd={onDragEnd}
                isEditExercises={isEditExercises.value}
              />
            ) : (
              <div
                style={{
                  height: 300,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  style={{
                    marginBottom: 24,
                  }}
                >
                  No Exercises
                </Typography>
                <Typography
                  style={{
                    color: '#FF4D4F',
                  }}
                >
                  Add at least 1 exercise to save.
                </Typography>
              </div>
            )}

            {isEditExercises.value && (
              <AddItemModal
                title="Add exercise"
                isShowAddFormButton={true}
                onAdd={handleAddExercisesToLesson}
                placeholderSearch="Search by exercise, category"
                options={exercisesData}
                searchValue={searchValue.value}
                onChange={onChangeSearchValue}
                content={
                  <InfiniteComp hasMore={hasMore.value} handleLoadMore={handleLoadMoreExercise}>
                    <Table
                      columns={columns}
                      dataSource={exercisesData}
                      total={99999}
                      tableKey={''}
                      queryState={{
                        page: 1,
                        limit: 99999,
                      }}
                      paginationConfigs={{
                        show: false,
                      }}
                      headerConfigs={{
                        show: false,
                      }}
                    />
                  </InfiniteComp>
                }
              />
            )}
          </>
        </BorderContainer>

        <BorderContainer>
          <div className="max-w-800">
            <Typography
              style={{ marginBottom: 24 }}
              size={20}
              weight={500}
              height={28}
              color={COLOR.surfaceNeutralBold['neutral-11']}
            >
              Thumbnail
            </Typography>
            <ThumbnailComp
              file={
                thumbnailUrl.value && !thumbnailUrl.value.includes('thumbnail-default')
                  ? thumbnailUrl.value
                  : ''
              }
              onChangeFiles={onChangeThumbnail}
              onDeleteThumbnail={handleRemoveThumbnail}
              handleGetWidthAndHeightThumbnail={handleGetWidthAndHeightThumbnail}
              title={
                <Typography
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    lineHeight: 'calc(20/14)',
                    color: COLOR_CONFIG['neutral-text'],
                  }}
                >
                  Thumbnail (optional)
                </Typography>
              }
            />

            {thumbnailUrl.value ? (
              <></>
            ) : (
              <Typography style={{ color: '#808080' }}>
                <i>
                  *If no thumbnail is uploaded, the default will be the thumbnail of the 2nd
                  exercise.
                </i>
              </Typography>
            )}
          </div>
        </BorderContainer>

        <ConfirmModal
          modalKey={MODAL_KEY.DELETE_LESSON}
          content={'Deleting will also remove them from all existing courses.'}
          header={`Delete lesson`}
          onCancel={() => closeModal(MODAL_KEY.DELETE_LESSON)}
          onSubmit={handleDeleteLesson}
        />
      </>
    </ContainerForm>
  );
};
